module.exports = "https://dashboard.cdn.gifty.nl/6016/images/emoti-1.png?d19331318800ea3be74d11be2a8c05fd";